import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(authed)/posts/page.tsx");
